import { apiClient } from './client';

/** saas-auth refresh body (handoff §3 step 2). Only accessToken and csrfToken are read. */
export interface RefreshResponse {
  accessToken?: string;
  expiresIn?: number;
  csrfToken?: string | null;
}

export const authApi = {
  /** POST {authOrigin}/api/auth/refresh — `{}` body so cookie-echo can add `csrfToken`. */
  async refresh(): Promise<RefreshResponse> {
    const res = await apiClient.post<RefreshResponse>('/api/auth/refresh', {});
    return res.data;
  },
  /** POST {authOrigin}/api/auth/logout. */
  async logout(): Promise<void> {
    await apiClient.post('/api/auth/logout', {});
  },
};
